import { render, staticRenderFns } from "./SampleIPS.vue?vue&type=template&id=4a117a89&scoped=true&"
import script from "./SampleIPS.vue?vue&type=script&lang=js&"
export * from "./SampleIPS.vue?vue&type=script&lang=js&"
import style0 from "./SampleIPS.vue?vue&type=style&index=0&id=4a117a89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a117a89",
  null
  
)

export default component.exports